import { ProfileType } from '@ixicare/resources';
import * as React from 'react';
import { observer } from 'mobx-react';
import { State } from '~/store/types';
import { t } from '~/i18n';
import ProfileFormContainer from '../Profile/ProfileForm';
import { useStores } from '~store/utils';

interface ResidentFormContainerProps {
  profile: State['residentDetail']['profile'];
}

const ResidentFormContainer: React.FC<ResidentFormContainerProps> = observer(({ profile }) => {
  const { permissions } = useStores();
  if (!permissions.has('can_create_profiles')) {
    return <p>{t('user-configuration.no-permissions')}</p>;
  }
  return (
    <ProfileFormContainer
      profileType={ProfileType.Resident}
      profile={profile ?? undefined}
      fields={['healthLevel', 'nationalNumber', 'livingUnit', 'phoneNumbers', 'birthday']}
      urlPath="residents"
      storeType="residents"
      donePath={'/residents'}
    />
  );
});

export default ResidentFormContainer;
